<template>
    <Box title="进度查询">
        <div class="infoBox">
            <div class="title">
                <span>维修单号</span>
               <span>{{data.OrderNo}}</span>
            </div>
            <div class="item" v-for="item in list">
                <img :src="item.Icon"/>
                <div>
                    <div>
                        <span>{{item.DelDate}}</span>
                        <span class="ProName">{{item.ProName}}</span>
                    </div>
                    <p v-html='item.UserName'></p>
                    <p>{{item.Phone}}</p>
                </div>
            </div>
        </div>
    </Box>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    export default {
        name: 'MaintenanceProgress',
        components: {
            Box
        },
        data() {
            return {
                data: this.$route.params.item,//基本数据
                list: [],//HTML需要数据
                ApiData:[],//api返回数据
            }
        },
        mounted() {

            //  对数据进行二次处理 分离手机号

            this.loadDataDefault();
        },methods:{
            loadDataDefault(){
                this.$post('api/Repair/OrderProDetailList',{
                    OrderNo:this.data.OrderNo
                }).then(result=>{
                    this.ApiData=result.OrderProDelList;
                    this.FactoryOperation();
                })
            },FactoryOperation(){
                if(this.ApiData.length===0){
                    this.$Toast('数据异常,请联系管理员！');
                    return false;
                }
                const newJson = []
                this.ApiData.map(e => {
                    const UserNameArr = e.UserName.split(',联系电话:')
                    const Icon = e.ProName.indexOf('维修申请') > -1 ? require('../../assets/img/dwx.png')
                        : e.ProName.indexOf('派工') > -1 ? require('../../assets/img/dpg.png')
                            : e.ProName.indexOf('接单') > -1 ? require('../../assets/img/djd.png')
                                : e.ProName.indexOf('审批') > -1 ? require('../../assets/img/dsp.png')
                                    : require('../../assets/img/dwx.png')
                    const Phone = !!UserNameArr[1] ? UserNameArr[UserNameArr.length - 1] : null
                    const newObj = Phone ? {...e,Phone,UserName: UserNameArr[0],Icon} : {...e, UserName: UserNameArr[0],Icon}
                    newJson.push(newObj)
                });
                this.list = newJson;
            }
        }
    }
</script>

<style scoped lang="scss">
    .title{
        display: flex;
        justify-content: space-between;
        border-bottom: 2px solid #f3f3f3;
        padding-bottom: 14px;
        margin-bottom: 42px;
        span:last-child{
            font-size: 29px;
            font-weight: 400;
        }
    }
    .item{
        display: flex;
        padding-bottom: 76px;
        border-left: 2px dashed $THEME-COLOR;
        margin: 0 18px;
        img{
            width: 54px;
            height: 54px;
            position: relative;
            left: -27px;
            border-radius: 50%;
        }
        &:last-child{
            border: none;
        }
        &>div{
            margin-left: 38px;
            flex: 1;
            position: relative;
            top: -5px;
            div{
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                span:first-child{
                    color: #858585;
                    font-size: 24px;
                    flex: 1;
                }
                span:last-child{
                    font-size: 26px;
                    color: #858585;
                }
            }
            p:nth-child(2){
                font-size: 30px;
                color: #333;
                font-weight: bold;
                margin-bottom: 6px;
            }
            p:last-child{
                font-size: 29px;
                color: #333;
            }
        }
        &:last-child .ProName{
            color: $THEME-COLOR;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/maintenanceProgress/maintenanceProgress.vue